import { createFeatureSelector, createSelector } from "@ngrx/store";
import { MuseumManageState } from "./reducers-museum";

/**
 * Top level selector for the MuseumManageState
 */
export const museumManageState = createFeatureSelector<MuseumManageState>('museumsManage');

export const getFoundMuseums = createSelector(
    museumManageState,
    (state: MuseumManageState) => state.entityData
);

export const getMuseumToEdit = createSelector(
    museumManageState,
    (state: MuseumManageState) => state.editEntityData
);

export const getMuseumToView = createSelector(
    museumManageState,
    (state: MuseumManageState) => state.viewEntityData
);

export const getMuseumCopyMode = createSelector(
    museumManageState,
    (state: MuseumManageState) => state.isCopy
);